import Vue from "vue";
import VueMask from "v-mask";
import bFormSlider from "vue-bootstrap-slider";
import "bootstrap-slider/dist/css/bootstrap-slider.css";

import Lang from "lang.js";
import vueSlider from "vue-slider-component";
import { store } from "~/frontend/store/store";

// Import tracking functions for global exposure (Datacrew requirements)
import { passParam } from "./utils/tracking";
import { trackQuotation } from "./services/quotationTrackingService";
import { getCustomParams } from "./utils/tracking";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

window.Vue = require("vue");

/**y
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default
    )
);

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const BootstrapVue = require("bootstrap-vue");
const VueScrollTo = require("vue-scrollto");

Vue.use(BootstrapVue);
Vue.use(VueMask);
Vue.use(VueScrollTo);

Vue.use(bFormSlider);
const messages = require("../../assets/js/ll_messages").default;
Vue.prototype.$trans = new Lang({
    messages,
    locale: window.default_locale,
    fallback: window.fallback_locale
});

$(document).ready(() => {
    $(".content-page img").addClass("img-fluid");

    $("[logout-link]").on("click", event => {
        event.preventDefault();
        axios
            .post("/hu/logout")
            .then(() => (window.location.href = "/" + window.default_locale));
    });
});

Vue.component("vue-slider", vueSlider);

Vue.filter("currency", value => {
    value = parseFloat(value);

    if (!isFinite(value) || (!value && value !== 0)) {
        return "";
    }

    var stringified = Math.abs(value);

    var _int = Math.round(stringified).toString();

    var i = _int.length % 3;

    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? " " : "") : "";

    var sign = value < 0 ? "-" : "";

    return sign + "" + head + _int.slice(i).replace(/(\d{3})(?=\d)/g, "$1 ");
});

Vue.filter("brandToUpper", function(value, brand) {
    if (!brand) return value;

    var replace = "^" + brand;
    var re = new RegExp(replace, "gm");

    return value.replace(re, brand.toUpperCase());
});

Vue.filter("round100", value => {
    value = parseFloat(value);

    return Math.round(value / 100) * 100;
});

const app = new Vue({
    el: "#app",
    store
});

// Expose tracking functions globally for GTM testing (Datacrew requirements)
window.passParam = passParam;

// Helper functions
window.getStoredParams = function() {
    return getCustomParams();
};

window.getQuotationDebugHistory = function() {
    const history = localStorage.getItem("nl_quotation_debug");
    return history ? JSON.parse(history) : [];
};

// Enhanced quotation dataLayer test
window.testQuotationDataLayer = async function() {
    try {
        const { trackQuotation } = await import(
            "./services/quotationTrackingService"
        );

        await trackQuotation({
            quotation_id: "TEST_" + Date.now(),
            email: "test@netlizing.hu",
            phone: "+36301234567",
            first_name: "Test",
            last_name: "User",
            company: "Test Company"
        });

        console.log("✅ Quotation dataLayer event sent successfully");
        console.log("📊 Current dataLayer:", window.dataLayer);
        console.log(
            "📋 Quotation debug history:",
            window.getQuotationDebugHistory()
        );

        return {
            success: true,
            dataLayer: window.dataLayer,
            debugHistory: window.getQuotationDebugHistory()
        };
    } catch (error) {
        console.error("❌ Quotation test failed:", error);
        return { success: false, error: error.message };
    }
};
